import { createLoadingScreen } from "../DomUtilities/ElementsCreator";
import openErrorModal from "../Error/ErrorModal";
import { deleteStore, fetchDeleteStoreModal } from "../HTTPRequests/StoreRequests";
import Mediator from "../Utilities/Mediator";

export default class DeleteStoreModal {
	loadingScreen: HTMLElement;
	storeId: string;
	editModalDiv: HTMLDivElement;

	constructor(storeId: string, editModal: HTMLDivElement) {
		this.loadingScreen = createLoadingScreen();
		this.storeId = storeId;
		this.editModalDiv = editModal;
	}

	public addDeleteModalClickListener() {
		const deleteButton: HTMLButtonElement = document.querySelector('#update-store-modal button');
		deleteButton.onclick = () => {
			document.body.append(this.loadingScreen);
			this.fetchDeleteModal();
		}
	}

	private fetchDeleteModal() {
		fetchDeleteStoreModal(this.storeId)
			.then((response: string) => {
				this.openDeleteModal(response);
			}, () => { //backend error
				openErrorModal();
			}).catch(() => { //frontend error
				openErrorModal();
			}).finally(() => {
				this.loadingScreen.remove();
			});
	}

	public openDeleteModal(modalHTMLString: string) {
		const modalDiv: HTMLDivElement = document.createElement("div");
		modalDiv.innerHTML = modalHTMLString;
		document.body.appendChild(modalDiv);

		const cancelButton: HTMLButtonElement = document.querySelector('#cancel');
		cancelButton.onclick = () => {
			modalDiv.remove();
		};

		const image: HTMLImageElement = document.querySelector('#delete-store-modal img[alt="close icon"]');
		image.onclick = () => {
			modalDiv.remove();
		}

		const saveButton: HTMLButtonElement = document.querySelector('#delete-store-modal button:last-child');
		saveButton.onclick = () => {
			document.body.append(this.loadingScreen);
			this.deleteStore(modalDiv);
		}
	}

	private deleteStore(modalDiv: HTMLDivElement) {
		deleteStore(this.storeId)
			.then(() => {
				modalDiv.remove();
				this.editModalDiv.remove();
				Mediator.emit("storeCrudOperationFinished");
			}, () => { //backend error
				openErrorModal();
			}).catch(() => { //frontend error
				openErrorModal();
			}).finally(() => {
				this.loadingScreen.remove();
			});
	}
}
